import React, { useState, useCallback } from 'react';
import moment from 'moment';
import { Container } from 'react-bootstrap';
import CommonTable from './table/CommonTable';
import DatePicker from './date/DatePicker';

const BusinessRevenue = () => {
  const dummyData = [
    {
      centerName: 'AMRIT HEART',
      studies: [
        {
          id: 94,
          studyName: 'VCC',
          contrast: true,
          govtPrice: '933',
          pvtPrice: '1200',
          centerPrice: '800',
          Modality: 'CT',
        },
      ],
      caseDate: '2024-11-01',
      patientName: 'Rajesh Kumar',
      patientID: 'APLO12345',
      panel: 'Government',
      assignments: ['Dr AMIT JHALANI', 'Dr MUKESH JI'],
      caseCompletion: '2024-11-04',
      images: '124',
      completedBy: 'Dr. Priya Verma',
      reportUploadTime: '2024-11-01T08:30:00',
      reportCompletionTime: '2024-11-01T09:15:00',
    },
    {
      centerName: 'Bhuvan Diagnostic Center',
      studies: [
        {
          id: 95,
          studyName: 'X-Ray',
          contrast: false,
          govtPrice: '400',
          pvtPrice: '600',
          centerPrice: '500',
          Modality: 'X-Ray',
        },
      ],
      caseDate: '2024-11-05',
      patientName: 'Sita Verma',
      patientID: 'APLO12346',
      panel: 'Private',
      assignments: ['Dr RAVI SHARMA'],
      caseCompletion: '2024-11-06',
      images: '50',
      completedBy: 'Dr. Ravi Kumar',
      reportUploadTime: '2024-11-05T09:00:00',
      reportCompletionTime: '2024-11-05T10:30:00',
    },
    {
      centerName: 'Boss Diagnostic',
      studies: [
        {
          id: 96,
          studyName: 'MRI Brain',
          contrast: true,
          govtPrice: '1500',
          pvtPrice: '1800',
          centerPrice: '1000',
          Modality: 'MRI',
        },
      ],
      caseDate: '2024-11-07',
      patientName: 'Vijay Singh',
      patientID: 'APLO12347',
      panel: 'Government',
      assignments: ['Dr ANITA KUMAR', 'Dr RAJESH KUMAR'],
      caseCompletion: '2024-11-10',
      images: '16',
      completedBy: 'Dr. Rajesh Singh',
      reportUploadTime: '2024-11-07T11:15:00',
      reportCompletionTime: '2024-11-07T12:30:00',
    },
    {
      centerName: 'Bikaner Imaging',
      studies: [
        {
          id: 97,
          studyName: 'CT Chest',
          contrast: false,
          govtPrice: '1200',
          pvtPrice: '1500',
          centerPrice: '1400',
          Modality: 'CT',
        },
      ],
      caseDate: '2024-11-12',
      patientName: 'Sunita Devi',
      patientID: 'APLO12348',
      panel: 'Private',
      assignments: ['Dr MUKESH JI'],
      caseCompletion: '2024-11-14',
      images: '27',
      completedBy: 'Dr. Mukesh Kumar',
      reportUploadTime: '2024-11-12T08:45:00',
      reportCompletionTime: '2024-11-12T10:00:00',
    },
    {
      centerName: 'BUNDELKHAND MRI & DIAGNOSTIC CENTER',
      studies: [
        {
          id: 98,
          studyName: 'Ultrasound Abdomen',
          contrast: false,
          govtPrice: '700',
          pvtPrice: '900',
          centerPrice: '800',
          Modality: 'Ultrasound',
        },
      ],
      caseDate: '2024-11-15',
      patientName: 'Amit Singh',
      patientID: 'APLO12349',
      panel: 'Private',
      assignments: ['Dr RAJESH KUMAR'],
      caseCompletion: '2024-11-18',
      images: '88',
      completedBy: 'Dr. Anita Verma',
      reportUploadTime: '2024-11-15T07:30:00',
      reportCompletionTime: '2024-11-15T08:45:00',
    },
    {
      centerName: 'Capital Imaging',
      studies: [
        {
          id: 99,
          studyName: 'CT Scan Brain',
          contrast: true,
          govtPrice: '1200',
          pvtPrice: '1500',
          centerPrice: '1000',
          Modality: 'CT',
        },
      ],
      caseDate: '2024-11-19',
      patientName: 'Neha Sharma',
      patientID: 'APLO12350',
      panel: 'Government',
      assignments: ['Dr ANITA KUMAR', 'Dr MUKESH JI', 'DR. Priya'],
      caseCompletion: '2024-11-22',
      images: '12',
      completedBy: 'Dr. Priya Verma',
      reportUploadTime: '2024-11-19T10:15:00',
      reportCompletionTime: '2024-11-19T11:45:00',
    },
    {
      centerName: 'Ganesh Diagnostic Delhi',
      studies: [
        {
          id: 100,
          studyName: 'X-Ray Chest',
          contrast: false,
          govtPrice: '350',
          pvtPrice: '450',
          centerPrice: '300',
          Modality: 'X-Ray',
        },
      ],
      caseDate: '2024-11-20',
      patientName: 'Ravi Yadav',
      patientID: 'APLO12351',
      panel: 'Private',
      assignments: ['Dr RAVI SHARMA'],
      caseCompletion: '2024-11-23',
      images: '30',
      completedBy: 'Dr. Ravi Yadav',
      reportUploadTime: '2024-11-20T09:00:00',
      reportCompletionTime: '2024-11-20T10:15:00',
    },
  ];

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isDataFetched, setIsDataFetched] = useState(true);

  const getFilteredData = useCallback(() => {
    if (!startDate || !endDate) {
      return dummyData;
    }

    return dummyData.filter((row) => {
      const caseDate = moment(row.caseDate);
      return caseDate.isBetween(moment(startDate), moment(endDate), 'day', '[]');
    });
  }, [startDate, endDate]);

  const calculateDoctorRevenue = (row) => {
    return row.studies.reduce((total, study) => {
      const price = row.panel === 'Government' ? parseFloat(study.govtPrice) : parseFloat(study.pvtPrice);
      return total + price;
    }, 0);
  };

  const calculateCenterRevenue = (row) => {
    return row.studies.reduce((total, study) => {
      return total + parseFloat(study.centerPrice);
    }, 0);
  };

  const calculateTotalRevenue = () => {
    const filteredData = getFilteredData();
    return filteredData.reduce((total, row) => {
      const doctorRevenue = calculateDoctorRevenue(row);
      const centerRevenue = calculateCenterRevenue(row);
      return total + doctorRevenue + centerRevenue;
    }, 0);
  };

  const totalRevenue = `₹${calculateTotalRevenue().toLocaleString()}`;

  const maxAssignments = Math.max(...dummyData.map((row) => row.assignments.length));

  const renderDate = useCallback((value) => <span>{moment(value).format('DD-MMM-YYYY')}</span>, []);

  const columns = [
    { accessor: 'caseDate', label: 'Case Date', render: renderDate },
    { accessor: 'patientName', label: 'Patient Name' },
    { accessor: 'patientID', label: 'Patient ID' },
    { accessor: 'panel', label: 'Panel' },
    ...Array.from({ length: maxAssignments }, (_, i) => ({
      accessor: `assignments[${i}]`,
      label: `${i + 1} Assignment`,
      render: (value, row) => (row.assignments[i] ? row.assignments[i] : '-'),
    })),
    { accessor: 'caseCompletion', label: 'Case Completion', render: renderDate },
    {
      accessor: 'doctorPrice',
      label: 'Doctor Price',
      render: (value, row) => {
        const revenue = calculateDoctorRevenue(row);
        return `₹${revenue.toLocaleString()}`;
      },
    },
    { accessor: 'centerName', label: 'Centre Name' },
    {
      accessor: 'centerPrice',
      label: 'Center Price',
      render: (value, row) => {
        const revenue = calculateCenterRevenue(row);
        return `₹${revenue.toLocaleString()}`;
      },
    },
    {
      accessor: 'studyNameAndModality',
      label: 'Study & Modality',
      render: (value, row) => {
        const study = row.studies[0];
        return `${study.studyName} (${study.Modality})`;
      },
    },
    {
      accessor: 'overallRevenue',
      label: 'Overall Revenue',
      render: (value, row) => {
        const doctorRevenue = calculateDoctorRevenue(row);
        const centerRevenue = calculateCenterRevenue(row);
        const total = doctorRevenue - centerRevenue;
        return `₹${total.toLocaleString()}`;
      },
    },
  ];

  return (
    <Container fluid className="px-0 text-nowrap">
      <div className="bg-white p-4 min-vh-100 shadow-sm">
        <h3 className="base-color mb-2">Business Revenue</h3>
        <div className="position-absolute mt-2 pt-1">
          <DatePicker setStartDate={setStartDate} setEndDate={setEndDate} setIsDataFetched={setIsDataFetched} />
        </div>
        <CommonTable
          data={getFilteredData()}
          columns={columns}
          loading={false}
          footerRow={{
            label: 'Total Revenue',
            colspan: columns.length - 1,
            value: totalRevenue,
          }}
        />
      </div>
    </Container>
  );
};

export default BusinessRevenue;
